(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["side-panel"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;
    root.classList.add('js-panels');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var opener = null;

    /* After a send, show the form again (name, email and phone kept, message cleared) */
    function showFields(scope) {
      var sent = scope.querySelector('[data-form-sent]');
      var fields = scope.querySelector('[data-form-fields]');
      if (!sent || !fields || !fields.hidden) return;
      sent.hidden = true;
      fields.hidden = false;
      var message = fields.querySelector('textarea');
      if (message) message.value = '';
    }

    function openPanel(panel, trigger) {
      if (!panel || typeof panel.showModal !== 'function') return false;
      if (panel.open) return true;
      /* Opened by the visitor (not the reopen after a send): start with a fresh form */
      if (trigger) showFields(panel);
      opener = trigger || document.activeElement;
      var drawer = document.querySelector('.site-header__drawer[open]');
      if (drawer) drawer.removeAttribute('open');
      panel.classList.remove('is-closing');
      panel.showModal();
      var field = panel.querySelector('input:not([type="hidden"]):not([readonly]), textarea, select');
      if (field) field.focus({ preventScroll: true });
      return true;
    }

    function closePanel(panel) {
      if (!panel || !panel.open || panel.classList.contains('is-closing')) return;
      var finish = function () {
        panel.classList.remove('is-closing');
        panel.close();
        if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
      };
      if (reduceMotion.matches) {
        finish();
        return;
      }
      panel.classList.add('is-closing');
      window.setTimeout(finish, 300);
    }

    /* Links to the contact page open the contact panel instead, except on the contact page itself */
    function contactPanelFor(link) {
      var panel = document.querySelector('[data-contact-panel]');
      if (!panel || link.hash || link.target === '_blank') return null;
      var path = panel.getAttribute('data-contact-path');
      if (!path || link.origin !== window.location.origin) return null;
      if (link.pathname !== path || window.location.pathname === path) return null;
      return panel;
    }

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;

      var trigger = event.target.closest('[data-side-panel-open]');
      if (trigger) {
        if (openPanel(document.getElementById(trigger.getAttribute('data-side-panel-open')), trigger)) event.preventDefault();
        return;
      }

      var again = event.target.closest('[data-form-again]');
      if (again) {
        var scope = again.closest('form') || document;
        showFields(scope);
        var first = scope.querySelector('[data-form-fields] input:not([type="hidden"]), [data-form-fields] textarea');
        if (first) first.focus();
        return;
      }

      var closer = event.target.closest('[data-side-panel-close]');
      if (closer) {
        event.preventDefault();
        closePanel(closer.closest('[data-side-panel]'));
        return;
      }

      /* A click on the backdrop lands on the dialog itself, outside its inner content */
      if (event.target.matches('[data-side-panel]')) {
        closePanel(event.target);
        return;
      }

      var link = event.target.closest('a[href]');
      if (!link) return;

      /* A link to #<panel id> on this page opens that panel */
      if (link.hash && link.pathname === window.location.pathname) {
        var target = document.getElementById(link.hash.slice(1));
        if (target && target.matches('[data-side-panel]')) {
          if (openPanel(target, link)) event.preventDefault();
          return;
        }
      }

      var contact = contactPanelFor(link);
      if (contact && openPanel(contact, link)) event.preventDefault();
    });

    document.querySelectorAll('[data-side-panel]').forEach(function (panel) {
      panel.addEventListener('cancel', function (event) {
        event.preventDefault();
        closePanel(panel);
      });
    });

    /* Reopen the panel whose form was just posted, so the thank-you or the errors show where the form was */
    function openOnLoad() {
      var waiting = Array.prototype.slice.call(document.querySelectorAll('[data-side-panel][data-open-on-load]'));
      var hash = window.location.hash.slice(1);
      var panel =
        waiting.filter(function (item) { return hash && (item.id === hash || item.getAttribute('data-form-id') === hash); })[0] ||
        waiting[0] ||
        (hash && document.querySelector('[data-side-panel]#' + CSS.escape(hash)));
      if (panel) openPanel(panel);

      /* Tidy the address bar, so a refresh does not reopen the thank-you */
      if (window.location.search.indexOf('contact_posted') !== -1) {
        var url = new URL(window.location.href);
        url.searchParams.delete('contact_posted');
        url.hash = '';
        window.history.replaceState(window.history.state, '', url);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openOnLoad);
    } else {
      openOnLoad();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
